<template>
  <div>
    <section class="order-steps">
      <div class="container narrow">
        <h2 class="section--title">3 ways to get in touch</h2>
        <div class="row">
          <div class="step-card col-12 col-md-4" data-aos="fade-in">
            <h3>Phone</h3>
            <p>Our friendly and knowledgable team are available for orders and enquiries anytime
              between 8am and 5:30pm daily, with courier delivery as standard.</p>
          </div>
          <div class="step-card col-12 col-md-4" data-aos="fade-in">
            <h3>Email</h3>
            <p>Email us at <a v-bind:href="'mailto:' + this.$root.store.contact_email">{{this.$root.store.contact_email}}</a>
              with the product names,
              reference numbers and
              quantities and your delivery details and we'll take it from there.</p>
          </div>
          <div class="step-card col-12 col-md-4" data-aos="fade-in">
            <h3>Share Favourites</h3>
            <p>We have a unique favouriting system. Simply favourite the wines you want, save a list and refer to it
              when you email or call.</p>
          </div>
        </div>
        <router-link :to="{ name: 'contact'}" title="'Link: Contact'" class="cta">
          Find out more
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'OrderSteps'
  }
</script>
